var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.771,
    viewBox: "0 0 20 14.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-hide-5584573",
    transform: "translate(161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16051",
    "data-name": "Group 16051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17362",
    "data-name": "Group 17362",
    transform: "translate(-161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16050",
    "data-name": "Group 16050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235908",
    "data-name": "Path 235908",
    d: "M122.487,268.05c-5.442,0-9.687,6.632-9.865,6.915a.892.892,0,0,0,0,.942c.178.283,4.423,6.915,9.865,6.915s9.687-6.632,9.865-6.915a.892.892,0,0,0,0-.942C132.174,274.682,127.929,268.05,122.487,268.05Zm0,13.1c-3.863,0-7.241-4.27-8.273-5.716,1.033-1.446,4.41-5.717,8.273-5.717s7.241,4.27,8.273,5.717C129.727,276.881,126.35,281.152,122.487,281.152Z",
    transform: "translate(-112.487 -268.05)",
    fill: "#2eaa69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_235909",
    "data-name": "Path 235909",
    d: "M426.55,422.05a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,426.55,422.05Zm0,7.1a2.6,2.6,0,1,1,2.6-2.6A2.606,2.606,0,0,1,426.55,429.152Z",
    transform: "translate(-416.551 -419.164)",
    fill: "#2eaa69"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.8b7d35481a7753b2958dde99b1a67bd5.svg";
export { ForwardRef as ReactComponent };